import React from "react";
import _ from "lodash";

import useGlobalSettings from "src/core/shared/hooks/useGlobalSettings";

import { IProduct } from "../api/products.api";

export const useProductLeadTimeGroup = () => {
  const [ { globalSettings } ] = useGlobalSettings();

  const getProductLeadTimeGroup = React.useCallback((product: IProduct) => {
    return _.find(globalSettings?.leadTimeGroups, ltg => ltg.id === product.leadTimeGroupId);
  }, [ globalSettings?.leadTimeGroups ]);

  return getProductLeadTimeGroup;
};
